<nav class="col-md-2 d-none d-md-block bg-light sidebar">
  <div class="sidebar-sticky container">
    <ul class="nav navbar-nav flex-columnz">

      <li class="nav-item" *ngFor="let route of routes">
        <a *ngIf="route.path != '' && showRoute(route)" class="nav-link" [routerLink]="[route.path]" routerLinkActive="active">
          <mat-icon>{{route.icon}}</mat-icon>
          {{route.title}}</a>
        <mat-divider *ngIf="route.path == ''"></mat-divider>
      </li>

    </ul>
  </div>
</nav>
